import { render, staticRenderFns } from "./AdTable.vue?vue&type=template&id=580d25e2"
import script from "./AdTable.vue?vue&type=script&lang=js"
export * from "./AdTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports